import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/pamia.png'


const _hoisted_1 = ["src"]

import { onBeforeUnmount, onMounted, ref } from "vue";
import { storeToRefs } from "pinia";
import { pamiaChatRepo } from "@/di/repositories";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { toggleModal } from "@/utils/Helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'PamiaWidget',
  setup(__props) {

const { session: userSession } = storeToRefs(useSessionStore());
const iframeUrl = ref("");
const loadingUrl = ref(true);

async function loadUrl() {
  loadingUrl.value = true;
  iframeUrl.value = "";
  if (!userSession.value) {
    // visitante usa a página pública da Pamia
    iframeUrl.value = `${process.env.VUE_APP_API_BASE_URL}pamia`;
    loadingUrl.value = false;
    return;
  }
  try {
    iframeUrl.value = (await pamiaChatRepo.getWebviewUrl()).url;
  } catch (e: any) {
    EventBus.$emit(EventBusNames.SHOW_ERROR_TOAST, {
      msg: e?.message || "Não foi possível abrir a Pamia, tente novamente",
    });
  } finally {
    loadingUrl.value = false;
  }
}

function openModal() {
  toggleModal("pamia-modal");
  loadUrl();
}
// no desktop a Pamia abre pelo item da navbar (OPEN_PAMIA); no celular, pelo botão flutuante
onMounted(() => EventBus.$on(EventBusNames.OPEN_PAMIA, openModal));
onBeforeUnmount(() => EventBus.$off(EventBusNames.OPEN_PAMIA, openModal));
const handleModalClosed = () => {
  iframeUrl.value = "";
};

return (_ctx: any,_cache: any) => {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: "pamia-fab position-fixed rounded-circle border-0 bg-white text-white d-flex d-md-none align-items-center justify-content-center",
      "aria-label": "Falar com a Pamia",
      onClick: openModal
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        height: "35"
      }, null, -1)
    ]))]),
    _createVNode(_component_ModalComponent, {
      id: "pamia-modal",
      backdrop: 'true',
      modalClass: "pamia-modal text-primary",
      size: "pamia-modal-dialog",
      bodyClass: "p-0 d-flex flex-column",
      onModalClosed: handleModalClosed
    }, {
      body: _withCtx(() => [
        (loadingUrl.value)
          ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
          : (iframeUrl.value)
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 1,
                src: iframeUrl.value,
                frameborder: "0",
                class: "flex-fill w-100 border-0"
              }, null, 8, _hoisted_1))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})